/**
 * HolidayBanner — slim auto-themed strip that appears on the storefront
 * when a holiday window is active. Dismissable; remembers per theme.
 */
import { X } from "lucide-react";

export default function HolidayBanner({ theme, onDismiss, dismissed,
                                          isPreview, cycleInfo }) {
  if (!theme || dismissed) return null;
  const p = theme.palette || {};
  return (
    <div
      className="hpz-holiday-banner"
      data-testid="plaza-holiday-banner"
      data-theme-key={theme.key}
      style={{
        background: p.banner_bg || "#1a1a1a",
        color: p.banner_fg || "#ffffff",
        transition: "background-color 600ms ease, color 600ms ease",
      }}
    >
      <span className="hpz-holiday-banner__emoji" aria-hidden>
        {theme.banner_emoji || "✨"}
      </span>
      <span className="hpz-holiday-banner__label">
        {theme.banner_label || theme.name}
      </span>
      {cycleInfo && (
        <span
          className="hpz-holiday-banner__cycle-pill"
          data-testid="plaza-holiday-cycle-pill"
          style={{
            background: p.banner_fg || "#ffffff",
            color: p.banner_bg || "#1a1a1a",
          }}
        >
          {cycleInfo.index} / {cycleInfo.total} · {cycleInfo.name}
        </span>
      )}
      {isPreview && !cycleInfo && (
        <span
          className="hpz-holiday-banner__preview-pill"
          data-testid="plaza-holiday-preview-pill"
          style={{
            background: p.banner_fg || "#ffffff",
            color: p.banner_bg || "#1a1a1a",
          }}
        >
          PREVIEW
        </span>
      )}
      {!cycleInfo && (
        <button
          className="hpz-holiday-banner__close"
          onClick={onDismiss}
          aria-label="Dismiss holiday banner"
          data-testid="plaza-holiday-banner-close"
          style={{ color: p.banner_fg || "#ffffff" }}
        >
          <X size={14} />
        </button>
      )}
    </div>
  );
}
